module.exports = __webpack_public_path__ + "static/media/jumbotronHome.d7df8514.jpg";